<template>
  <div class="navbar-header-model" v-show="tabsSession.length">
    <!-- O vue3-tabs usa `document` ao carregar: fica dentro do ClientOnly, cujo
         conteúdo o Nuxt tira do bundle do servidor -->
    <ClientOnly>
      <template v-if="!aguardando">
        <tabs v-model="selectedTab">
          <tab
            v-for="(tab, i) in tabsSession"
            :key="`t${i}`"
            :val="i"
            :label="tab.name"
            :indicator="true"
            @click="emits('changeSession', { part: i, session: 0 })"
          />
          <!--
        <tab :key="`t${tabs.length}`" :val="tabs[(tabs.length - 1)]?.name" :label="translate.soon" :disabled="true"
          class="disable" />
        -->
        </tabs>
        <tab-panels v-model="selectedTab" :animate="true" :swipeable="true">
          <tab-panel
            v-for="(tab, i) in tabsSession"
            :key="`tp${i}`"
            :val="i"
            class="font-tab"
          >
            <div class="row d-flex justify-content-start">
              <div
                v-for="(part, j) in tab.sessions"
                :key="j"
                class="card px-3 pt-3 col-lg-3"
              >
                <div
                  v-if="thumbPhotos[i][j] && part.block === 'false'"
                  :class="
                    part.block === 'false'
                      ? sessionActive == j
                        ? 'card-box-active'
                        : 'card-box'
                      : 'card-box-block'
                  "
                  @click="
                    part.block === 'true'
                      ? showModalPlans('Clicar em uma sessão de fotos bloqueada')
                      : emits('changeSession', { part: i, session: j })
                  "
                  :style="`background-image: url('${thumbPhotos[i][j]}');background-size:cover;background-repeat: no-repeat;background-position: center center`"
                >
                  <font-awesome
                    v-if="part.block === 'true'"
                    :icon="['fas', 'lock']"
                    size="md"
                  />
                </div>
                <div
                  v-else-if="part.block === 'true' && thumbPhotos[i]?.[j]"
                  class="card-box-block-blur"
                  @click="showModalPlans('Clicar em uma sessão de fotos bloqueada')"
                >
                  <div
                    class="card-box-block-blur-bg"
                    :style="`background-image: url('${thumbPhotos[i][j]}')`"
                  ></div>
                  <font-awesome
                    class="lock-icon-red"
                    :icon="['fas', 'lock']"
                    size="md"
                  />
                </div>
                <div
                  v-else-if="part.block === 'true'"
                  class="card-box-block"
                  @click="showModalPlans('Clicar em uma sessão de fotos bloqueada')"
                >
                  <font-awesome
                    :icon="['fas', 'lock']"
                    size="md"
                  />
                </div>
                <div
                  v-else
                  :class="
                    part.block === 'false'
                      ? sessionActive == j
                        ? 'card-box-active'
                        : 'card-box'
                      : 'card-box-block'
                  "
                  @click="
                    part.block === 'true'
                      ? showModalPlans('Clicar em uma sessão de fotos bloqueada')
                      : emits('changeSession', { part: i, session: j })
                  "
                >
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <span
                  :class="
                    part.block === 'false'
                      ? sessionActive == j
                        ? 'part-name py-1'
                        : 'part-name-gray py-1'
                      : 'part-name-block py-1'
                  "
                  >{{ part.name }}</span
                >
              </div>
            </div>
          </tab-panel>
        </tab-panels>
      </template>
    </ClientOnly>
    <!-- Caixas neutras, na mesma altura: no HTML do SSR e até montar, e, para
         quem está logado, até a versão dele chegar (a do SSR é a anônima, com
         cadeados que podem não valer para ele). Sem as miniaturas, que já vão
         no payload (base64 em dobro no HTML). -->
    <template v-if="!montado || aguardando">
      <div class="tabs-fallback">
        <span
          v-for="(tab, i) in tabsSession"
          :key="`tf${i}`"
          :class="{ 'tab-fallback-active': i === selectedTab }"
          >{{ tab.name }}</span
        >
      </div>
      <div class="row d-flex justify-content-start">
        <div
          v-for="(part, j) in tabsSession[selectedTab]?.sessions ?? []"
          :key="`sf${j}`"
          class="card px-3 pt-3 col-lg-3"
        >
          <div class="card-box-block"></div>
          <span class="part-name-gray py-1">{{ part.name }}</span>
        </div>
      </div>
    </template>
    <div class="video-button-container">
      <NuxtLink
        :to="{ name: 'language-modelos-name-video', params: { name: route.params.name, language: route.params.language } }"
        class="video-button"
      >
        {{ translate.seeVideo }}
        <font-awesome :icon="['fas', 'arrow-right']" size="sm" />
      </NuxtLink>
    </div>
    <hr class="hr-desktop" />
  </div>
</template>
<script lang="ts" setup>
import { Tabs, Tab, TabPanels, TabPanel } from "vue3-tabs";

const route = useRoute();
const emits = defineEmits(["changeSession", "showModalSubscribePlans"]);
// `aguardando`: logado, a versão do usuário ainda não chegou.
const props = defineProps([
  "parts",
  "translate",
  "sessionActive",
  "changeSelectedTab",
  "thumbPhotos",
  "aguardando",
]);
const tabsSession = computed(() => props.parts);
const selectedTab = computed(() => props.changeSelectedTab);
const montado = ref(false);
onMounted(() => {
  montado.value = true;
});

function showModalPlans(acionador: string) {
  emits("showModalSubscribePlans", true);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "paywall",
    paywall: { acionador: acionador },
  });
}
</script>
<style scoped>
.tab-panels >>> .tab-panel {
  width: 97%;
}
.navbar-header-model >>> .tab {
  height: 64px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 61px;
  top: 5px;
}
.navbar-header-model .tabs > .active {
  border: 0px;
}
.navbar-header-model .tabs > .active::after {
  content: "";
  background: #000000;
  position: absolute;
  width: 100%;
  height: 3px;
  bottom: 0px;
}
.tabs >>> .tab {
  padding: 0px 20px;
  cursor: pointer;
}
.tabs >>> .active .tab {
  color: #000000;
  border-color: #000000;
  font-weight: bold;
  font-family: "Roboto-Bold";
}
.button--more svg {
  color: #b20000;
}
.button--more {
  font-family: "Exo-2";
  font-weight: bold;
  color: #898989;
  font-size: 16px;
}
.small svg {
  margin-right: 5px;
}
.card img {
  width: 470px;
  height: 701px;
  object-fit: cover;
}
.card {
  background-color: #fff;
}
.card-box {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 10%;
  border: 1px solid #dddddd;
  cursor: pointer;
  opacity: 0.8;
}
.card-box-active {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 10%;
  border: 2px solid #000000;
  cursor: pointer;
}
.card-box-block {
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  border: 1px solid #dddddd;
  background-color: #eeeeee;
  cursor: pointer;
}
.part-name {
  color: #5b5858;
  font-family: "Roboto-Bold";
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
}
.part-name-gray {
  color: #5b5858;
  font-family: "Roboto-Bold";
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 0;
}
.part-name-block {
  opacity: 0.5;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
  margin-top: 3px;
}
.fa-lock {
  color: #b20000;
}
.disable {
  cursor: not-allowed;
}
.col-lg-3 {
  width: 25%;
}
.card-box-block-blur {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border-radius: 10%;
  border: 1px solid #dddddd;
  cursor: pointer;
}
.card-box-block-blur-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  filter: blur(1.5px);
  transform: scale(1.1);
  opacity: 0.5;
}
.lock-icon-red {
  position: relative;
  z-index: 1;
  color: #b20000;
}
/* botão de vídeo só no mobile e linha só no desktop, por CSS (era isMobile()) */
.video-button-container {
  display: none;
  justify-content: center;
  padding: 30px 0;
}
.tabs-fallback {
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  height: 64px;
  line-height: 61px;
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
}
.tabs-fallback span {
  padding: 0px 20px;
}
.tabs-fallback .tab-fallback-active {
  color: #000000;
  font-family: "Roboto-Bold";
  font-weight: bold;
}
.video-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #000000;
  color: #ffffff;
  font-family: "Roboto-Bold";
  font-size: 16px;
  padding: 12px 32px;
  border-radius: 30px;
  text-decoration: none;
  transition: opacity 0.2s;
}
.video-button:hover {
  opacity: 0.85;
  color: #ffffff;
}

.video-button .svg-inline--fa {
  color: #B20000;
}

/* regras mobile 1300px */
@media screen and (max-width: 1300px) {
  .col-lg-3 {
    width: 25%;
  }
  .tabs >>> .tab,
  .tabs-fallback span {
    padding: 0px 15px;
  }
  .card-box-active {
    width: 62px;
    height: 62px;
  }
  .card-box {
    width: 62px;
    height: 62px;   
  }  
  .card-box-block {
    width: 62px;
    height: 62px;
  }
  .card-box-block-blur {
    width: 62px;
    height: 62px;
  }
}

/* regras mobile 769px */
@media screen and (max-width: 769px) {
  .video-button-container {
    display: flex;
  }
  .hr-desktop {
    display: none;
  }
  .col-lg-3 {
    width: 25%;
  }
  .tabs >>> .tab {
    padding: 0px 15px;
  }  
  .card-box-active {
    width: 67px;
    height: 67px;
  }
  .card-box {
    width: 67px;
    height: 67px;   
  }  
  .card-box-block {
    width: 67px;
    height: 67px;
  }
  .card-box-block-blur {
    width: 67px;
    height: 67px;
  }
}

/* regras mobile 992px: miniatura fluida e sempre quadrada (background cover),
   acompanhando proporcionalmente a largura da celula em vez de tamanho fixo */
@media screen and (max-width: 992px) {
  .card-box,
  .card-box-active,
  .card-box-block,
  .card-box-block-blur {
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
  }
}
</style>
